import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SmartInspectRoiForm from "../consultant/SmartInspectRoiForm";
import { siGetAssessment, siUpdateAssessment, siListQuestions, groupSteps } from "../lib/smartInspectApi";
import { Button } from "../components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function SmartInspectRoiDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [config, setConfig] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [questions, a] = await Promise.all([siListQuestions(), siGetAssessment(id)]);
        setConfig(groupSteps(questions));
        setAssessment(a);
      } finally { setLoading(false); }
    })();
  }, [id]);

  const onPersist = async (partialAnswers, { step, complete }) => {
    const a = await siUpdateAssessment(id, { answers: partialAnswers, current_step: step, complete: !!complete });
    setAssessment(a);
    return a;
  };

  if (loading || !config || !assessment) {
    return <div className="p-10 flex items-center justify-center"><Loader2 className="animate-spin text-indigo-600" /></div>;
  }

  return (
    <div data-testid="si-assessment-detail" className="p-6">
      <Button data-testid="si-back-btn" variant="ghost" onClick={() => nav("/admin/smartinspect/roi-assessments")} className="mb-4">
        <ArrowLeft size={16} className="mr-1" /> Back to ROI Assessments
      </Button>
      <div className="mb-4">
        <h1 className="text-xl font-bold text-slate-900">{assessment.answers?.company_name || "SmartInspect ROI Assessment"}</h1>
        <p className="text-sm text-slate-500 capitalize">{assessment.mode} · {assessment.status === "inputs_complete" ? "Inputs complete" : "Draft"}</p>
      </div>
      <SmartInspectRoiForm config={config} assessment={assessment} onPersist={onPersist} />
    </div>
  );
}
